import React, {
  useState,
  useCallback,
  useImperativeHandle,
  forwardRef,
  useContext,
} from "react";
import { SimpleDialog, Button } from "simple-ui-components";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";

import { AlertMessage } from "../../theme";
import { AuthContext } from "../authContextProvider";
import { getTranslation } from "../languageProvider";

export const WarnToLogout = forwardRef((props, ref) => {
  const { Dialog, DialogBody, DialogFooter } = SimpleDialog;

  const { logoutHandler } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState({});
  const handleClose = useCallback(() => {
    setOpen(false);
    logoutHandler();
  }, [logoutHandler]);

  // trigger from props
  useImperativeHandle(ref, () => ({
    Message(info) {
      setOpen(true);
      setMessage(info);
    },
  }));

  return (
    <>
      {open && (
        <Dialog
          theme="default"
          size="sm"
          close={handleClose}
          open={open}
          title={getTranslation("0064")}
        >
          <DialogBody>
            <AlertMessage>
              <span>{message.success}</span>
              <b>{message.warning}</b>
            </AlertMessage>
          </DialogBody>
          <DialogFooter multiple={true}>
            <Button
              type="button"
              clicked={logoutHandler}
              icon={<ExitToAppIcon />}
              text={getTranslation("0063")}
              className="btn-danger"
              theme="danger"
              style={{ marginLeft: "auto" }}
            />
          </DialogFooter>
        </Dialog>
      )}
    </>
  );
});
